@if (formGroup) {
  <div [formGroup]="formGroup">
    <div class="grid-container border-one-pixel-solid-gray margin-bottom">
      <div class="grid-x padding-all">
        <div class="cell large-3 bold select-lines" [ngClass]="{ 'red' : formGroup.get('documentGroup')?.invalid }">
          *Document Group:
        </div>
        <div class="cell large-6 select-lines">
          @if (documentGroups?.length > 0) {
            <ng-select formControlName="documentGroup" [items]="documentGroups" bindLabel="name" bindValue="id" (ngModelChange)="documentGroupChanged($event)"></ng-select>
          }
          <text-loader [run]="documentGroups == null || documentGroups.length === 0" [text]="'Loading Document Groups'" [tickType]="'.'" [interval]="3000"></text-loader>
        </div>
        <div class="cell large-3 bold padding-left select-lines">
          &nbsp;
        </div>
        <div class="cell large-3 bold select-lines" [ngClass]="{ 'red': documentsInvalid }">
          *Type / Name of Document:
        </div>
        <div class="cell large-6 select-lines">
          @if (documentTypes?.length > 0) {
            <ng-select formControlName="documentType" (ngModelChange)="docTypeChanged()" [items]="documentTypes" bindLabel="name" bindValue="id"></ng-select>
          }
          <text-loader [run]="documentTypes == null || documentTypes.length === 0" [text]="'Loading Document Types'" [tickType]="'.'" [interval]="3000"></text-loader>
        </div>
        <div class="cell large-3 bold padding-left select-lines">
          @if (formGroup.get('documentGroup')?.touched && formGroup.get('documentGroup')?.invalid) {
            <span class="red">
              Select a Document Group
            </span>
          }
        </div>
        <div class="cell large-12 bold" [ngClass]="{ 'red' : !hasSearchOption }">
          * Look Up Values:
        </div>
        <div class="cell large-12 bold padding-left">
          Minimum Selection: 1 Lookup Field
        </div>
        <div class="cell large-2 bold padding-left-large text-align-right padding-right-small">
          API Number:
        </div>
        <div class="cell large-2">
          <input type="text" formControlName="apiNumber" (keydown)="invalidateField('apiFound')" />
        </div>
        <div class="cell large-2 padding-left">
          @if (!runApiSearch) {
            <button class="button" (click)="apiSearch()" [disabled]="runApiSearch"><svg-icon icon="icon-data-lookup" class="small black"></svg-icon></button>
          }
          <text-loader [run]="runApiSearch" [text]="'Searching'" [tickType]="'.'" [interval]="3000"></text-loader>
          @if (apiSearchRun || apiValid) {
            <span>
              @if (formGroup.get('apiNumber')?.dirty) {
                <span class="red">
                  @if (apiValid) {
                    <svg-icon class="large green" icon="icon-checkbox"></svg-icon>
                  }
                  @if (!apiValid) {
                    @if (!apiValid) {
                      <svg-icon class="tiny red" icon="icon-alert"></svg-icon>
                    }
                    No Results
                  }
                </span>
              }
            </span>
          }
        </div>
        <div class="cell large-2 bold padding-left text-align-right padding-right-small">
          Application Number:
        </div>
        <div class="cell large-2">
          <input type="text" formControlName="applicationNumber" (keydown)="invalidateField('applicationNumberFound')" />
        </div>
        <div class="cell large-2 padding-left">
          @if (!runAppSearch) {
            <button class="button" (click)="appNumberSearch()" [disabled]="runAppSearch"><svg-icon icon="icon-data-lookup" class="small black"></svg-icon></button>
          }
          <text-loader [run]="runAppSearch" [text]="'Searching'" [tickType]="'.'" [interval]="3000"></text-loader>
          @if (applicationSearchRun || applicationNumberValid) {
            <span>
              @if (formGroup.get('applicationNumber').dirty) {
                <span class="red">
                  @if (applicationNumberValid) {
                    <svg-icon class="large green" icon="icon-checkbox"></svg-icon>
                  }
                  @if (!applicationNumberValid) {
                    @if (!applicationNumberValid) {
                      <svg-icon class="tiny red" icon="icon-alert"></svg-icon>
                    }
                    No Results
                  }
                </span>
              }
            </span>
          }
        </div>
        <div class="cell large-2 bold text-align-right padding-right-small">
          RICS Owner Number:
        </div>
        <div class="cell large-2">
          <input type="text" formControlName="organizationNumber" (keydown)="invalidateField('organizationNumberFound')" />
        </div>
        <div class="cell large-2 padding-left">
          @if (!runOrgSearch) {
            <button class="button" (click)="organizationSearch()" [disabled]="runOrgSearch"><svg-icon icon="icon-data-lookup" class="small black"></svg-icon></button>
          }
          <text-loader [run]="runOrgSearch" [text]="'Searching'" [tickType]="'.'" [interval]="3000"></text-loader>
          @if (organizationSearchRun || organizationNumberValid) {
            <span>
              @if (formGroup.get('organizationNumber')?.dirty) {
                <span class="red">
                  @if (organizationNumberValid) {
                    <svg-icon class="large green" icon="icon-checkbox"></svg-icon>
                  }
                  @if (!organizationNumberValid) {
                    @if (!organizationNumberValid) {
                      <svg-icon class="tiny red" icon="icon-alert"></svg-icon>
                    }
                    No Results
                  }
                </span>
              }
            </span>
          }
        </div>
        <div class="cell large-2 bold text-align-right padding-right-small">
          RBDMS Owner Number:
        </div>
        <div class="cell large-2">
          <input type="text" formControlName="rbdmsNumber" (keydown)="invalidateField('rbdmsNumberFound')" />
        </div>
        <div class="cell large-2 padding-left">
          @if (!runRBDMSSearch) {
            <button class="button" (click)="rbdmsSearch()"><svg-icon icon="icon-data-lookup" class="small black"></svg-icon></button>
          }
          <text-loader [run]="runRBDMSSearch" [text]="'Searching'" [tickType]="'.'" [interval]="3000"></text-loader>
          @if (rbdmsNumberSearchRun || rbdmsNumberValid) {
            <span>
              @if (formGroup.get('rbdmsNumber')?.dirty) {
                <span class="red">
                  @if (rbdmsNumberValid) {
                    <svg-icon class="large green" icon="icon-checkbox"></svg-icon>
                  }
                  @if (!rbdmsNumberValid) {
                    @if (!rbdmsNumberValid) {
                      <svg-icon class="tiny red" icon="icon-alert"></svg-icon>
                    }
                    No Results
                  }
                </span>
              }
            </span>
          }
        </div>
        <div class="cell large-12">
          <div class="checkbox">
            <input id="legal" formControlName="legalReview" type="checkbox" class="show-for-sr" />
            <label for="legal">
              <span class="checkbox-box" aria-hidden="true">
                <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
              </span>
              Legal Review Required
            </label>
          </div>
        </div>
        <div class="cell large-12">
          <div class="checkbox">
            <input id="confidential" formControlName="confidential" type="checkbox" class="show-for-sr" />
            <label for="confidential">
              <span class="checkbox-box" aria-hidden="true">
                <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
              </span>
              Private &amp; Confidential
            </label>
          </div>
        </div>
        <div class="cell large-4 bold" [ngClass]="{ 'red': pagesInvalid }">
          *Number of Pages (Including Coversheet):
        </div>
        <div class="cell large-1">
          <input type="number" formControlName="pages" min="0" />
        </div>
        <div class="cell large-7">
          &nbsp;
        </div>
      </div>
    </div>
  </div>
}


